<template>
  <div class="popup" v-if="marker">
    <div class="popup__details">
      <div class="popup__close icon-close" @click="closePopup(false)"></div>
      <div class="popup__top">
        <div class="popup__header">
          <div class="popup__name" v-if="marker.name">{{ marker.name }}</div>
          <div class="popup__distance" v-if="marker.distance">{{ marker.distance.replace('.', ',') }} {{ $t('matrix') }}</div>
        </div>
        <div class="popup__contact">
          <div class="popup__location" if="marker.address">{{ marker.address }}</div>
          <div class="popup__location" if="marker.address">
            <span v-if="marker.zipcode">{{ marker.zipcode }},</span>
            {{ marker.city }}</div>
          <div class="popup__location" if="marker.address">{{ marker.state }}</div><br/>
          <div v-if="phone">{{ phone }}</div>
        </div>
      </div>
      <div class="popup__bottom">
        <div class="popup__opening_hours" v-if="hours">
          <div class="popup__open">
            <div>{{ $t('monFri') }}</div>
            <div class="popup__hour">
              <span v-if="hours[1]">{{ hours[1].open.slice(0, 2) }} - {{ hours[1].close.slice(0, 2) }}</span>
              <span v-else>{{ $t('closed') }}</span>
            </div>
          </div>
          <div class="popup__open">
            <div>{{ $t('sat') }}</div>
            <div class="popup__hour">
              <span v-if="hours[6]">{{ hours[6].open.slice(0, 2) }} - {{ hours[6].close.slice(0, 2) }}</span>
              <span v-else>{{ $t('closed') }}</span>
            </div>
          </div>
          <div class="popup__open">
            <div>{{ $t('sun') }}</div>
            <div class="popup__hour">
              <span v-if="hours[0]">{{ hours[0].open.slice(0, 2) }} - {{ hours[0].close.slice(0, 2) }}</span>
              <span v-else>{{ $t('closed') }}</span>
            </div>
          </div>
        </div>
        <div class="popup__links">
          <a target="_blank" :href="url">{{ $t('directions') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Popup',
    computed: {
      marker () {
        return this.$store.state.selectedMarker
      },
      phone () {
        if (this.marker.details && this.marker.details.phone) {
          return this.marker.details.phone.replace('-', ' - ')
        } else if (this.marker.phone) {
          return this.marker.phone.replace('-', ' - ')
        } else {
          return null
        }
      },
      hours () {
        if (!(((this.marker || {}).details || {}).opening_hours || {}).periods) return null
        const periods = this.marker.details.opening_hours.periods

        let hours = {}

        for (const period of periods) {
          Object.assign(hours, {[period.open.day]: (hours[period.open.day] || {})})

          if (hours[period.open.day].open === undefined) {
            Object.assign(hours[period.open.day], {open: period.open.time})
          }
          Object.assign(hours[period.open.day], {close: period.close.time})
        }
        return hours
      },
      url () {
        if (!this.marker) return null

        if (this.marker.googleID) { // eslint-disable-line
          return `https://www.google.com/maps/place/?q=place_id:${this.marker.googleID}`
        }

        let saddr = ''

        if (this.$store.state.currentPosition) {
          saddr = `saddr=${this.$store.state.currentPosition.latitude},${this.$store.state.currentPosition.longitude}&`
        }
        const daddr = `daddr=${this.marker.latitude},${this.marker.longitude}`
        return `https://maps.google.com/maps?${saddr}${daddr}`
      }
    },
    methods: {
      closePopup () {
        this.$store.commit('selectedMarker', null)
      }
    },
    watch: {
      marker (marker) {
        if (!marker || !marker.googleID) return

        this.$http.get(`/stores/google/details/${marker.googleID}`)
          .then(response => {
            this.$set(this.marker, 'details', response.data)
          })
          .catch(err => {
            console.error(err)
          })
      }
    }
  }
</script>

<style scoped>
  .popup {
    background: rgba(255, 255, 255, .9);
    z-index: 100;
    box-shadow: 0 0 10px rgba(0, 0, 0, .2);
    text-align: left;
    font-size: 12px;
    line-height: 18px;
    margin-bottom: 20px;
    position: relative;
    -webkit-backdrop-filter: blur(3px);
    pointer-events: auto;
  }
  .popup__close {
    position: absolute;
    top: 0;
    right: 0;
    background: #FFF;
    width: 30px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    cursor: pointer;
  }
  .popup__top {
    padding-bottom: 20px;
  }
  .popup__bottom {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding-top: 20px;
    border-top: 1px solid #DDD;
  }
  .popup__header {
    display: flex;
    justify-content: space-between;
  }
  .popup__name {
    font-size: .9rem;
    padding-bottom: 20px;
  }
  .popup__opening_hours {
    width: 44%;
  }
  .popup__open {
    display: flex;
    justify-content: space-between;
  }
  .popup__hour {
    text-align: right;
  }
  .popup__links {
    display: flex;
    flex-direction: column;
    text-align: right;
    flex: 1;
  }
  .popup__details {
    padding: 40px 20px 20px;
  }
  @media only screen and (max-device-width: 768px) {
    .popup {
      max-width: 320px;
      width: 100%;
      margin-left: auto;
      margin-right: auto;
    }
  }
</style>

<style src="@/assets/dw-icons/styles.css" lang="css"></style>



// WEBPACK FOOTER //
// Popup.vue?e41e3fe4